export class Carrier {
  carrierId: any;
  scac: any;
  businessType: any;
  scacName: any;
  carrierType: any;
  dunsNumber: any;
  dunsPlus: any;
  uniqueEntityIdentifier: any;
  samUeiExpDate: any;
  smartWayId: any;
  smartWayScore: any;
  rateFileReceipt: any;
  rateFileReceiptDate: any;
  organizationId: any;
  carrierStatus: any;
  deletedId: any;
  deletedDate: any;
  shipmentRptContFirstName: any;
  shipmentRptContLastName: any;
  shipmentRptContMiddleInitial: any;
  shipmentRptContEmail: any;
  shipmentRptContPhone: any;
  shipmentRptContPhoneExtension: any;
  updateProgram: any;
  updateId: any;
  updateDate: any;
  organizationEntity: any;
  carrierApprovalInformationEntity: CarrierApprovalInformationEntity[];
  carrierToSocioeconomicIndicatorEntity: any;
  changedApprovalType: any;
  carrierContactInfoEntity:any;

  constructor(carrierId: any, scac: any, businessType: any, scacName: any, carrierType: any, dunsNumber: any,
              dunsPlus: any, smartWayId: any, smartWayScore: any, rateFileReceipt: any, rateFileReceiptDate: any, organizationId: any,
              carrierStatus: any, deletedId: any, deletedDate: any, shipmentRptContFirstName: any,
              shipmentRptContLastName: any, shipmentRptContMiddleInitial: any, shipmentRptContEmail: any,
              shipmentRptContPhone: any, shipmentRptContPhoneExtension: any, updateProgram: any,
              updateId: any, updateDate: any, organizationEntity: any, carrierApprovalInformationEntity: CarrierApprovalInformationEntity[],
              carrierToSocioeconomicIndicatorEntity: any, changedApprovalType: any) {
    this.carrierId = carrierId;
    this.scac = scac;
    this.businessType = businessType;
    this.scacName = scacName;
    this.carrierType = carrierType;
    this.dunsNumber = dunsNumber;
    this.dunsPlus = dunsPlus;
    this.smartWayId = smartWayId;
    this.smartWayScore = smartWayScore;
    this.rateFileReceipt = rateFileReceipt;
    this.rateFileReceiptDate = rateFileReceiptDate;
    this.organizationId = organizationId;
    this.carrierStatus = carrierStatus;
    this.deletedId = deletedId;
    this.deletedDate = deletedDate;
    this.shipmentRptContFirstName = shipmentRptContFirstName;
    this.shipmentRptContLastName = shipmentRptContLastName;
    this.shipmentRptContMiddleInitial = shipmentRptContMiddleInitial;
    this.shipmentRptContEmail = shipmentRptContEmail;
    this.shipmentRptContPhone = shipmentRptContPhone;
    this.shipmentRptContPhoneExtension = shipmentRptContPhoneExtension;
    this.updateProgram = updateProgram;
    this.updateId = updateId;
    this.updateDate = updateDate;
    this.organizationEntity = organizationEntity;
    this.carrierApprovalInformationEntity = carrierApprovalInformationEntity;
    this.carrierToSocioeconomicIndicatorEntity = carrierToSocioeconomicIndicatorEntity;
    this.changedApprovalType = changedApprovalType;
  }
}

export class CarrierApprovalInformationEntity {
  carrierTransportationTypeId: any;
  carrierId: any;
  approvalType: any;
  approvalNew: any;
  approvalDate: any;
  approvalId: any;
  tpa: any;
  tpaNumber: any;
  tpaDate: any;
  insuranceShortName: any;
  insuranceIdentifier: any;
  insuranceExpiryDate: any;
  customerSatisfactionIndex: any;
  usDotNumber: any;
  fmcOtiNumber: any;
  ffNumber: any;
  mcNumber: any;
  suspended: any;
  suspendedDate: any;
  bondIdentifier: any;
  bondDate: any;
  updateProgram: any;
  updateId: any;
  updateDate: any;
  revoked: any;
  revokedDate: any;
  constructor(carrierTransportationTypeId: any, carrierId: any, approvalType: any, approvalNew: any, approvalDate: any, approvalId: any,
  tpa: any, tpaNumber: any, tpaDate: any, insuranceShortName: any, insuranceIdentifier: any, insuranceExpiryDate: any, customerSatisfactionIndex: any,
  suspended: any, suspendedDate: any, bondIdentifier: any, bondDate: any, updateProgram: any, updateId: any, updateDate: any, revoked: any, revokedDate: any) {
    this.carrierTransportationTypeId  = carrierTransportationTypeId;
    this.carrierId  = carrierId;
    this.approvalType  = approvalType;
    this.approvalNew  = approvalNew;
    this.approvalDate  = approvalDate;
    this.approvalId  = approvalId;
    this.tpa  = tpa;
    this.tpaNumber  = tpaNumber;
    this.tpaDate  = tpaDate;
    this.insuranceShortName  = insuranceShortName;
    this.insuranceIdentifier  = insuranceIdentifier;
    this.insuranceExpiryDate  = insuranceExpiryDate;
    this.customerSatisfactionIndex  = customerSatisfactionIndex;
    this.suspended  = suspended;
    this.suspendedDate  = suspendedDate;
    this.bondIdentifier  = bondIdentifier;
    this.bondDate  = bondDate;
    this.updateProgram  = updateProgram;
    this.updateId  = updateId;
    this.updateDate  = updateDate;
    this.revoked = revoked;
    this.revokedDate = revokedDate;
  }
}

